import React, {Component} from 'react';
import Button from '../Button';
import PropTypes from 'prop-types';
import FontAwesome from 'react-fontawesome';

export default class ProductList extends Component {
  constructor(props, context) {
    super(props, context);
    this.onSelect = this.onSelect.bind(this);
  }

  static propTypes = {
    onNew: PropTypes.func.isRequired,
    onSelect: PropTypes.func.isRequired,
    products: PropTypes.array.isRequired,
    keyName: PropTypes.string.isRequired,
    selectedIndex: PropTypes.number
  };

  onSelect(event) {
    const index = parseInt(event && event.target && event.target.dataset && event.target.dataset.index, 10);
    if (typeof index !== 'number' || isNaN(index)) {
      return;
    }

    this.props.onSelect(index);
    this.setState({
      selectedIndex: index
    });
  }

  render() {
    let listItems = this.props.products.map((product, index) => {
      const key = product.token || index;
      const className = (index === this.props.selectedIndex)? 'selected' : '';
      const value = product[this.props.keyName] || 'Missing Product Name';
      // Show an active icon. The icon is not clickable though.
      const active = <FontAwesome name={product.active ? "toggle-on" : "toggle-off"}/>;
      return (
        <li key={key}
            className={className}
            data-index={index}
            onClick={this.onSelect}>
          {active} {value}
        </li>);
    });

    return (
        <div className="product-list-component">
          <div className="product-list-component-title">Products</div>
          <ul onClick={this.onSelect}>{listItems}</ul>
          <Button onClick={this.props.onNew}>New Product</Button>
        </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/ProductList/index.jsx
 **/